// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { LeadFormCompanySize, LeadFormInquiry, LeadSource, LeadForm } from "../schema";

export function serialize_LeadForm(obj: LeadForm): string {
  const serialized = ((value: {
    comment: string;
    company: string;
    companySize: LeadFormCompanySize;
    country: string;
    email: string;
    firstName: string;
    function: string;
    gRecaptchaResponse: string;
    howDidYouFindUs: string;
    inquiry: LeadFormInquiry;
    lastName: string;
    leadSource: LeadSource;
    phone: string;
    utmCampaign: string;
    utmContent: string;
    utmId: string;
    utmMedium: string;
    utmSource: string;
    utmTerm: string;
  }): unknown => {
    return {
      comment: ((value: string): unknown => {
        return value;
      })(value["comment"]),
      company: ((value: string): unknown => {
        return value;
      })(value["company"]),
      companySize: ((value: "PLEASE_CHOOSE" | "1_10" | "11_100" | "101_500" | "501_1000" | "1001_5000" | "5000PLUS"): unknown => {
        return value;
      })(value["companySize"]),
      country: ((value: string): unknown => {
        return value;
      })(value["country"]),
      email: ((value: string): unknown => {
        return value;
      })(value["email"]),
      firstName: ((value: string): unknown => {
        return value;
      })(value["firstName"]),
      function: ((value: string): unknown => {
        return value;
      })(value["function"]),
      gRecaptchaResponse: ((value: string): unknown => {
        return value;
      })(value["gRecaptchaResponse"]),
      howDidYouFindUs: ((value: string): unknown => {
        return value;
      })(value["howDidYouFindUs"]),
      inquiry: ((value: "PLEASE_CHOOSE" | "FOR_ENTERPRISE" | "FOR_INDIVIDUALS" | "FOR_TEAMS"): unknown => {
        return value;
      })(value["inquiry"]),
      lastName: ((value: string): unknown => {
        return value;
      })(value["lastName"]),
      leadSource: ((
        value:
          | "RENEWAL_FAILED"
          | "CANCELATION"
          | "CONTACTFORM"
          | "MANUAL"
          | "TRIAL_REQUEST"
          | "WHITE_PAPER_DOWNLOAD"
          | "FREE_ABSTRACTS"
          | "PURCHASE_FAILED"
          | "PURCHASE_FAILED_OLD"
          | "ACTIONABLE_LANDING_PAGE"
          | "CUSTOMER_STORIES_LANDING_PAGE"
          | "SUPPORT_FORM"
          | "LEADERSFUTURE_LANDING_PAGE"
          | "TEAMDEVELOPMENT_LANDING_PAGE"
          | "EMPLOYEEENGAGEMENT_LANDING_PAGE"
          | "EMPLOYEETRAINING_LANDING_PAGE"
          | "CORPORATELEARNING_LANDING_PAGE"
          | "LEARNINGDEVELOPMENT_LANDING_PAGE"
          | "MICROLEARNING_LANDING_PAGE"
          | "SKILLSOFT_LANDING_PAGE"
          | "STROER_LANDING_PAGE"
          | "LMS_LANDINGPAGE"
          | "MICROLEARNING_LANDINGPAGE"
          | "ENTERPRISE_PRODUCTS"
          | "SOLUTIONS_PAGE"
          | "SOLUTIONS_UPSKILLING"
          | "SOLUTIONS_DEI"
          | "SOLUTIONS_HEALTH_WELLBEING"
          | "SOLUTIONS_LEARNING_PLATFORM_STRATEGY"
          | "SOLUTIONS_TALENT_DEVELOPMENT"
          | "SOLUTIONS_COLLABORATIVE_LEARNING"
          | "SOLUTIONS_LEARNING_RESOURCE_LIBRARY"
          | "SOLUTIONS_EFFECTIVE_LEADERS"
          | "WELCOME_PAGE"
          | "BUSINESS_BOOK_SUMMARY_LANDINGPAGE"
          | "GRAPH_CONNECTOR_LANDINGPAGE",
      ): unknown => {
        return value;
      })(value["leadSource"]),
      phone: ((value: string): unknown => {
        return value;
      })(value["phone"]),
      utmCampaign: ((value: string): unknown => {
        return value;
      })(value["utmCampaign"]),
      utmContent: ((value: string): unknown => {
        return value;
      })(value["utmContent"]),
      utmId: ((value: string): unknown => {
        return value;
      })(value["utmId"]),
      utmMedium: ((value: string): unknown => {
        return value;
      })(value["utmMedium"]),
      utmSource: ((value: string): unknown => {
        return value;
      })(value["utmSource"]),
      utmTerm: ((value: string): unknown => {
        return value;
      })(value["utmTerm"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_LeadForm(str: string): ParserResult<LeadForm> {
  return ((
    value: unknown,
  ): ParserResult<{
    comment: string;
    company: string;
    companySize: LeadFormCompanySize;
    country: string;
    email: string;
    firstName: string;
    function: string;
    gRecaptchaResponse: string;
    howDidYouFindUs: string;
    inquiry: LeadFormInquiry;
    lastName: string;
    leadSource: LeadSource;
    phone: string;
    utmCampaign: string;
    utmContent: string;
    utmId: string;
    utmMedium: string;
    utmSource: string;
    utmTerm: string;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/LeadForm]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/LeadForm]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "comment")) {
      return { success: false, reason: `[#/components/schemas/LeadForm/comment]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'comment'.` };
    }
    const parsed_comment = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/LeadForm/comment]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["comment"]);
    })();
    if (!parsed_comment.success) {
      return { success: false, reason: parsed_comment.reason };
    }
    if (!hasProp(value, "company")) {
      return { success: false, reason: `[#/components/schemas/LeadForm/company]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'company'.` };
    }
    const parsed_company = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/LeadForm/company]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["company"]);
    })();
    if (!parsed_company.success) {
      return { success: false, reason: parsed_company.reason };
    }
    if (!hasProp(value, "companySize")) {
      return { success: false, reason: `[#/components/schemas/LeadForm/companySize]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'companySize'.` };
    }
    const parsed_companySize = ((): ParserResult<LeadFormCompanySize> => {
      return ((value: unknown): ParserResult<LeadFormCompanySize> => {
        return ((value: unknown): ParserResult<"PLEASE_CHOOSE" | "1_10" | "11_100" | "101_500" | "501_1000" | "1001_5000" | "5000PLUS"> => {
          if (typeof value !== "string") {
            return { success: false, reason: `[#/components/schemas/LeadFormCompanySize]: '${value}' expected to be of type string.` };
          }
          switch (value) {
            case "PLEASE_CHOOSE":
              return { success: true, value: "PLEASE_CHOOSE" };
            case "1_10":
              return { success: true, value: "1_10" };
            case "11_100":
              return { success: true, value: "11_100" };
            case "101_500":
              return { success: true, value: "101_500" };
            case "501_1000":
              return { success: true, value: "501_1000" };
            case "1001_5000":
              return { success: true, value: "1001_5000" };
            case "5000PLUS":
              return { success: true, value: "5000PLUS" };
            default:
              return { success: false, reason: `[#/components/schemas/LeadFormCompanySize]: '${value}' expected to be enum, one of 'PLEASE_CHOOSE, 1_10, 11_100, 101_500, 501_1000, 1001_5000, 5000PLUS'.` };
          }
        })(value);
      })(value["companySize"]);
    })();
    if (!parsed_companySize.success) {
      return { success: false, reason: parsed_companySize.reason };
    }
    if (!hasProp(value, "country")) {
      return { success: false, reason: `[#/components/schemas/LeadForm/country]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'country'.` };
    }
    const parsed_country = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/LeadForm/country]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["country"]);
    })();
    if (!parsed_country.success) {
      return { success: false, reason: parsed_country.reason };
    }
    if (!hasProp(value, "email")) {
      return { success: false, reason: `[#/components/schemas/LeadForm/email]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'email'.` };
    }
    const parsed_email = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/LeadForm/email]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["email"]);
    })();
    if (!parsed_email.success) {
      return { success: false, reason: parsed_email.reason };
    }
    if (!hasProp(value, "firstName")) {
      return { success: false, reason: `[#/components/schemas/LeadForm/firstName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'firstName'.` };
    }
    const parsed_firstName = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/LeadForm/firstName]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["firstName"]);
    })();
    if (!parsed_firstName.success) {
      return { success: false, reason: parsed_firstName.reason };
    }
    if (!hasProp(value, "function")) {
      return { success: false, reason: `[#/components/schemas/LeadForm/function]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'function'.` };
    }
    const parsed_function = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/LeadForm/function]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["function"]);
    })();
    if (!parsed_function.success) {
      return { success: false, reason: parsed_function.reason };
    }
    if (!hasProp(value, "gRecaptchaResponse")) {
      return { success: false, reason: `[#/components/schemas/LeadForm/gRecaptchaResponse]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'gRecaptchaResponse'.` };
    }
    const parsed_gRecaptchaResponse = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/LeadForm/gRecaptchaResponse]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["gRecaptchaResponse"]);
    })();
    if (!parsed_gRecaptchaResponse.success) {
      return { success: false, reason: parsed_gRecaptchaResponse.reason };
    }
    if (!hasProp(value, "howDidYouFindUs")) {
      return { success: false, reason: `[#/components/schemas/LeadForm/howDidYouFindUs]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'howDidYouFindUs'.` };
    }
    const parsed_howDidYouFindUs = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/LeadForm/howDidYouFindUs]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["howDidYouFindUs"]);
    })();
    if (!parsed_howDidYouFindUs.success) {
      return { success: false, reason: parsed_howDidYouFindUs.reason };
    }
    if (!hasProp(value, "inquiry")) {
      return { success: false, reason: `[#/components/schemas/LeadForm/inquiry]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'inquiry'.` };
    }
    const parsed_inquiry = ((): ParserResult<LeadFormInquiry> => {
      return ((value: unknown): ParserResult<LeadFormInquiry> => {
        return ((value: unknown): ParserResult<"PLEASE_CHOOSE" | "FOR_ENTERPRISE" | "FOR_INDIVIDUALS" | "FOR_TEAMS"> => {
          if (typeof value !== "string") {
            return { success: false, reason: `[#/components/schemas/LeadFormInquiry]: '${value}' expected to be of type string.` };
          }
          switch (value) {
            case "PLEASE_CHOOSE":
              return { success: true, value: "PLEASE_CHOOSE" };
            case "FOR_ENTERPRISE":
              return { success: true, value: "FOR_ENTERPRISE" };
            case "FOR_INDIVIDUALS":
              return { success: true, value: "FOR_INDIVIDUALS" };
            case "FOR_TEAMS":
              return { success: true, value: "FOR_TEAMS" };
            default:
              return { success: false, reason: `[#/components/schemas/LeadFormInquiry]: '${value}' expected to be enum, one of 'PLEASE_CHOOSE, FOR_ENTERPRISE, FOR_INDIVIDUALS, FOR_TEAMS'.` };
          }
        })(value);
      })(value["inquiry"]);
    })();
    if (!parsed_inquiry.success) {
      return { success: false, reason: parsed_inquiry.reason };
    }
    if (!hasProp(value, "lastName")) {
      return { success: false, reason: `[#/components/schemas/LeadForm/lastName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'lastName'.` };
    }
    const parsed_lastName = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/LeadForm/lastName]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["lastName"]);
    })();
    if (!parsed_lastName.success) {
      return { success: false, reason: parsed_lastName.reason };
    }
    if (!hasProp(value, "leadSource")) {
      return { success: false, reason: `[#/components/schemas/LeadForm/leadSource]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'leadSource'.` };
    }
    const parsed_leadSource = ((): ParserResult<LeadSource> => {
      return ((value: unknown): ParserResult<LeadSource> => {
        return ((
          value: unknown,
        ): ParserResult<
          | "RENEWAL_FAILED"
          | "CANCELATION"
          | "CONTACTFORM"
          | "MANUAL"
          | "TRIAL_REQUEST"
          | "WHITE_PAPER_DOWNLOAD"
          | "FREE_ABSTRACTS"
          | "PURCHASE_FAILED"
          | "PURCHASE_FAILED_OLD"
          | "ACTIONABLE_LANDING_PAGE"
          | "CUSTOMER_STORIES_LANDING_PAGE"
          | "SUPPORT_FORM"
          | "LEADERSFUTURE_LANDING_PAGE"
          | "TEAMDEVELOPMENT_LANDING_PAGE"
          | "EMPLOYEEENGAGEMENT_LANDING_PAGE"
          | "EMPLOYEETRAINING_LANDING_PAGE"
          | "CORPORATELEARNING_LANDING_PAGE"
          | "LEARNINGDEVELOPMENT_LANDING_PAGE"
          | "MICROLEARNING_LANDING_PAGE"
          | "SKILLSOFT_LANDING_PAGE"
          | "STROER_LANDING_PAGE"
          | "LMS_LANDINGPAGE"
          | "MICROLEARNING_LANDINGPAGE"
          | "ENTERPRISE_PRODUCTS"
          | "SOLUTIONS_PAGE"
          | "SOLUTIONS_UPSKILLING"
          | "SOLUTIONS_DEI"
          | "SOLUTIONS_HEALTH_WELLBEING"
          | "SOLUTIONS_LEARNING_PLATFORM_STRATEGY"
          | "SOLUTIONS_TALENT_DEVELOPMENT"
          | "SOLUTIONS_COLLABORATIVE_LEARNING"
          | "SOLUTIONS_LEARNING_RESOURCE_LIBRARY"
          | "SOLUTIONS_EFFECTIVE_LEADERS"
          | "WELCOME_PAGE"
          | "BUSINESS_BOOK_SUMMARY_LANDINGPAGE"
          | "GRAPH_CONNECTOR_LANDINGPAGE"
        > => {
          if (typeof value !== "string") {
            return { success: false, reason: `[#/components/schemas/LeadSource]: '${value}' expected to be of type string.` };
          }
          switch (value) {
            case "RENEWAL_FAILED":
              return { success: true, value: "RENEWAL_FAILED" };
            case "CANCELATION":
              return { success: true, value: "CANCELATION" };
            case "CONTACTFORM":
              return { success: true, value: "CONTACTFORM" };
            case "MANUAL":
              return { success: true, value: "MANUAL" };
            case "TRIAL_REQUEST":
              return { success: true, value: "TRIAL_REQUEST" };
            case "WHITE_PAPER_DOWNLOAD":
              return { success: true, value: "WHITE_PAPER_DOWNLOAD" };
            case "FREE_ABSTRACTS":
              return { success: true, value: "FREE_ABSTRACTS" };
            case "PURCHASE_FAILED":
              return { success: true, value: "PURCHASE_FAILED" };
            case "PURCHASE_FAILED_OLD":
              return { success: true, value: "PURCHASE_FAILED_OLD" };
            case "ACTIONABLE_LANDING_PAGE":
              return { success: true, value: "ACTIONABLE_LANDING_PAGE" };
            case "CUSTOMER_STORIES_LANDING_PAGE":
              return { success: true, value: "CUSTOMER_STORIES_LANDING_PAGE" };
            case "SUPPORT_FORM":
              return { success: true, value: "SUPPORT_FORM" };
            case "LEADERSFUTURE_LANDING_PAGE":
              return { success: true, value: "LEADERSFUTURE_LANDING_PAGE" };
            case "TEAMDEVELOPMENT_LANDING_PAGE":
              return { success: true, value: "TEAMDEVELOPMENT_LANDING_PAGE" };
            case "EMPLOYEEENGAGEMENT_LANDING_PAGE":
              return { success: true, value: "EMPLOYEEENGAGEMENT_LANDING_PAGE" };
            case "EMPLOYEETRAINING_LANDING_PAGE":
              return { success: true, value: "EMPLOYEETRAINING_LANDING_PAGE" };
            case "CORPORATELEARNING_LANDING_PAGE":
              return { success: true, value: "CORPORATELEARNING_LANDING_PAGE" };
            case "LEARNINGDEVELOPMENT_LANDING_PAGE":
              return { success: true, value: "LEARNINGDEVELOPMENT_LANDING_PAGE" };
            case "MICROLEARNING_LANDING_PAGE":
              return { success: true, value: "MICROLEARNING_LANDING_PAGE" };
            case "SKILLSOFT_LANDING_PAGE":
              return { success: true, value: "SKILLSOFT_LANDING_PAGE" };
            case "STROER_LANDING_PAGE":
              return { success: true, value: "STROER_LANDING_PAGE" };
            case "LMS_LANDINGPAGE":
              return { success: true, value: "LMS_LANDINGPAGE" };
            case "MICROLEARNING_LANDINGPAGE":
              return { success: true, value: "MICROLEARNING_LANDINGPAGE" };
            case "ENTERPRISE_PRODUCTS":
              return { success: true, value: "ENTERPRISE_PRODUCTS" };
            case "SOLUTIONS_PAGE":
              return { success: true, value: "SOLUTIONS_PAGE" };
            case "SOLUTIONS_UPSKILLING":
              return { success: true, value: "SOLUTIONS_UPSKILLING" };
            case "SOLUTIONS_DEI":
              return { success: true, value: "SOLUTIONS_DEI" };
            case "SOLUTIONS_HEALTH_WELLBEING":
              return { success: true, value: "SOLUTIONS_HEALTH_WELLBEING" };
            case "SOLUTIONS_LEARNING_PLATFORM_STRATEGY":
              return { success: true, value: "SOLUTIONS_LEARNING_PLATFORM_STRATEGY" };
            case "SOLUTIONS_TALENT_DEVELOPMENT":
              return { success: true, value: "SOLUTIONS_TALENT_DEVELOPMENT" };
            case "SOLUTIONS_COLLABORATIVE_LEARNING":
              return { success: true, value: "SOLUTIONS_COLLABORATIVE_LEARNING" };
            case "SOLUTIONS_LEARNING_RESOURCE_LIBRARY":
              return { success: true, value: "SOLUTIONS_LEARNING_RESOURCE_LIBRARY" };
            case "SOLUTIONS_EFFECTIVE_LEADERS":
              return { success: true, value: "SOLUTIONS_EFFECTIVE_LEADERS" };
            case "WELCOME_PAGE":
              return { success: true, value: "WELCOME_PAGE" };
            case "BUSINESS_BOOK_SUMMARY_LANDINGPAGE":
              return { success: true, value: "BUSINESS_BOOK_SUMMARY_LANDINGPAGE" };
            case "GRAPH_CONNECTOR_LANDINGPAGE":
              return { success: true, value: "GRAPH_CONNECTOR_LANDINGPAGE" };
            default:
              return {
                success: false,
                reason: `[#/components/schemas/LeadSource]: '${value}' expected to be enum, one of 'RENEWAL_FAILED, CANCELATION, CONTACTFORM, MANUAL, TRIAL_REQUEST, WHITE_PAPER_DOWNLOAD, FREE_ABSTRACTS, PURCHASE_FAILED, PURCHASE_FAILED_OLD, ACTIONABLE_LANDING_PAGE, CUSTOMER_STORIES_LANDING_PAGE, SUPPORT_FORM, LEADERSFUTURE_LANDING_PAGE, TEAMDEVELOPMENT_LANDING_PAGE, EMPLOYEEENGAGEMENT_LANDING_PAGE, EMPLOYEETRAINING_LANDING_PAGE, CORPORATELEARNING_LANDING_PAGE, LEARNINGDEVELOPMENT_LANDING_PAGE, MICROLEARNING_LANDING_PAGE, SKILLSOFT_LANDING_PAGE, STROER_LANDING_PAGE, LMS_LANDINGPAGE, MICROLEARNING_LANDINGPAGE, ENTERPRISE_PRODUCTS, SOLUTIONS_PAGE, SOLUTIONS_UPSKILLING, SOLUTIONS_DEI, SOLUTIONS_HEALTH_WELLBEING, SOLUTIONS_LEARNING_PLATFORM_STRATEGY, SOLUTIONS_TALENT_DEVELOPMENT, SOLUTIONS_COLLABORATIVE_LEARNING, SOLUTIONS_LEARNING_RESOURCE_LIBRARY, SOLUTIONS_EFFECTIVE_LEADERS, WELCOME_PAGE, BUSINESS_BOOK_SUMMARY_LANDINGPAGE, GRAPH_CONNECTOR_LANDINGPAGE'.`,
              };
          }
        })(value);
      })(value["leadSource"]);
    })();
    if (!parsed_leadSource.success) {
      return { success: false, reason: parsed_leadSource.reason };
    }
    if (!hasProp(value, "phone")) {
      return { success: false, reason: `[#/components/schemas/LeadForm/phone]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'phone'.` };
    }
    const parsed_phone = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/LeadForm/phone]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["phone"]);
    })();
    if (!parsed_phone.success) {
      return { success: false, reason: parsed_phone.reason };
    }
    if (!hasProp(value, "utmCampaign")) {
      return { success: false, reason: `[#/components/schemas/LeadForm/utmCampaign]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'utmCampaign'.` };
    }
    const parsed_utmCampaign = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/LeadForm/utmCampaign]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["utmCampaign"]);
    })();
    if (!parsed_utmCampaign.success) {
      return { success: false, reason: parsed_utmCampaign.reason };
    }
    if (!hasProp(value, "utmContent")) {
      return { success: false, reason: `[#/components/schemas/LeadForm/utmContent]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'utmContent'.` };
    }
    const parsed_utmContent = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/LeadForm/utmContent]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["utmContent"]);
    })();
    if (!parsed_utmContent.success) {
      return { success: false, reason: parsed_utmContent.reason };
    }
    if (!hasProp(value, "utmId")) {
      return { success: false, reason: `[#/components/schemas/LeadForm/utmId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'utmId'.` };
    }
    const parsed_utmId = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/LeadForm/utmId]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["utmId"]);
    })();
    if (!parsed_utmId.success) {
      return { success: false, reason: parsed_utmId.reason };
    }
    if (!hasProp(value, "utmMedium")) {
      return { success: false, reason: `[#/components/schemas/LeadForm/utmMedium]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'utmMedium'.` };
    }
    const parsed_utmMedium = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/LeadForm/utmMedium]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["utmMedium"]);
    })();
    if (!parsed_utmMedium.success) {
      return { success: false, reason: parsed_utmMedium.reason };
    }
    if (!hasProp(value, "utmSource")) {
      return { success: false, reason: `[#/components/schemas/LeadForm/utmSource]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'utmSource'.` };
    }
    const parsed_utmSource = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/LeadForm/utmSource]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["utmSource"]);
    })();
    if (!parsed_utmSource.success) {
      return { success: false, reason: parsed_utmSource.reason };
    }
    if (!hasProp(value, "utmTerm")) {
      return { success: false, reason: `[#/components/schemas/LeadForm/utmTerm]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'utmTerm'.` };
    }
    const parsed_utmTerm = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/LeadForm/utmTerm]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["utmTerm"]);
    })();
    if (!parsed_utmTerm.success) {
      return { success: false, reason: parsed_utmTerm.reason };
    }
    return {
      success: true,
      value: {
        comment: parsed_comment.value,
        company: parsed_company.value,
        companySize: parsed_companySize.value,
        country: parsed_country.value,
        email: parsed_email.value,
        firstName: parsed_firstName.value,
        function: parsed_function.value,
        gRecaptchaResponse: parsed_gRecaptchaResponse.value,
        howDidYouFindUs: parsed_howDidYouFindUs.value,
        inquiry: parsed_inquiry.value,
        lastName: parsed_lastName.value,
        leadSource: parsed_leadSource.value,
        phone: parsed_phone.value,
        utmCampaign: parsed_utmCampaign.value,
        utmContent: parsed_utmContent.value,
        utmId: parsed_utmId.value,
        utmMedium: parsed_utmMedium.value,
        utmSource: parsed_utmSource.value,
        utmTerm: parsed_utmTerm.value,
      },
    };
  })(parseJsonWithNumbersAsBigint(str));
}
